const validateEmail = (email) => {
  if (typeof email !== 'string') {
    return false
  }
  const emailRegexp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

  return emailRegexp.test(email)
}

export default validateEmail
